import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-donutchart',
  templateUrl: './donutchart.component.html',
  styleUrls: ['./donutchart.component.scss']
})
export class DonutchartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
